<template lang="pug">
  v-card
    v-toolbar.elevation-0(height="45" color="gray")
      v-toolbar-title
        h1.subheading Ticket By User
    div#ticket-line
</template>

<script>
import ticketService from '../../../service.js'
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters("location", ["location"]),
  },
  watch: {
    location() {
      this.getAllTicketByUser()
    }
  },
  mounted() {
    this.getAllTicketByUser()
  },
  methods: {
    getAllTicketByUser() {
      return ticketService.getAllTicketByUser(this.location.storeID)
      .then(data => {
        if(data){
          var newData = []
          data.forEach(row =>{
            newData.push([row.fullName, row.ticketCount])
          })

          var HighChartLine = $('#ticket-line')
          if (HighChartLine.length) {

            HighChartLine.highcharts({
                credits: false, // Disable HighCharts logo
                colors: ['#4a89dc', '#3bafda', '#8A1B1D'],// Set Colors
                chart: {
                  type: 'column'
                },
                title: {
                  text: null
                },
                tooltip: {
                  pointFormat: '{series.name}: <b>{point.y:.1f}</b>'
                },
                plotOptions: {
                  showInLegend: true
                },
                xAxis: {
                  type: 'category',
                  labels: {
                    rotation: -45,
                    style: {
                      fontSize: '13px',
                      fontFamily: 'Verdana, sans-serif'
                    }
                  }
                },
                yAxis: {
                  min: 0,
                  title: {
                    text: 'User Count'
                  }
                },
                legend: {
                  enabled: false,

                },
                series: [{
                  name: 'Status',
                  data: newData,
                  dataLabels: {
                    enabled: true,
                    rotation: -90,
                    color: '#FFFFFF',
                    align: 'right',
                    format: '{point.y:.1f}', // one decimal
                    y: 10, // 10 pixels down from the top
                    style: {
                      fontSize: '13px',
                      fontFamily: 'Verdana, sans-serif'
                    }
                  }
                }]
            })
          }
        }
      })
    }
  }
}
</script>
